import { render, staticRenderFns } from "./ViewerSlot.vue?vue&type=template&id=61bf976e&scoped=true&"
import script from "./ViewerSlot.vue?vue&type=script&lang=ts&"
export * from "./ViewerSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf976e",
  null
  
)

export default component.exports